const logo = require("../assests/adalogo.png");

export const image = {
    logo : logo
}